import { Rocket } from 'lucide-react'
import { PageHeader } from '@/components/shared/PageHeader'
import { EmptyState } from '@/components/shared/EmptyState'

interface PlataformaPageProps {
  variant?: 'onboarding' | 'orgs'
}

export function PlataformaPage({ variant = 'onboarding' }: PlataformaPageProps) {
  const isOnboarding = variant === 'onboarding'
  return (
    <div className="space-y-6">
      <PageHeader
        title={isOnboarding ? 'Onboarding' : 'Organizaciones'}
        description={
          isOnboarding
            ? 'Gestión de onboarding de nuevas empresas en la plataforma.'
            : 'Administración de organizaciones registradas en Kashio.'
        }
      />
      <EmptyState
        icon={<Rocket size={24} />}
        title="Próximamente"
        description="Esta sección es exclusiva para empleados Kashio."
      />
    </div>
  )
}
